import React from 'react';
import { Button, makeStyles } from "@fluentui/react-components";
import "../project-form.scss";
import PropTypes from 'prop-types';

const useStyles = makeStyles({
    submitButton: {
        backgroundColor: '#0e75bb',
        color: 'white',
        fontSize: '12px',
        height: '36px',
        minWidth: '10%',

        '&:hover': {
        backgroundColor: '#273c6e',
        color: 'white',
        },

        '&[disabled], &[aria-disabled="true"]': {
        backgroundColor: '#c7c7c7',
        color: '#ffffff',
        cursor: 'not-allowed',
        pointerEvents: 'none',
        },

        '&[disabled]:hover, &[aria-disabled="true"]:hover': {
        backgroundColor: '#c7c7c7',
        color: '#ffffff',
        },
    },
    cancelButton: {
        backgroundColor: 'white',
        color: '#0e75bb',
        height: '36px',
        border: '1px solid #0e75bb !important',
        minWidth: '10%',
        marginRight: '15px',
        '&:hover': {
            backgroundColor: '#273c6e',
            color: 'white'
        },
        '&[disabled], &[aria-disabled="true"]': {
            backgroundColor: '#c7c7c7',
            color: '#ffffff',
            cursor: 'not-allowed',
            pointerEvents: 'none',
            border: '1px solid #c7c7c7 !important',
        },

        '&[disabled]:hover, &[aria-disabled="true"]:hover': {
            backgroundColor: '#c7c7c7',
            color: '#ffffff',
        },
    }
});

function ProjectSubmitCancel({
    isSubmitting,
    isValid,
    isEdit,
    submitForm,
    setCancel,
    labels
}) {
    const styles = useStyles();
    return (
    <div className='submit-align'>
        <Button
            onClick={setCancel}
            className={styles.cancelButton}
            disabled={isSubmitting}
        >Cancel</Button>
        <Button
            disabled={isSubmitting || !isValid}
            appearance='primary'
            className={styles.submitButton}
            onClick={submitForm}
        >{isEdit ? "Save" : `Create ${labels?.ProjectSingular ?? "Project"}`}</Button>
    </div>
    )
}

ProjectSubmitCancel.propTypes = {
    isSubmitting: PropTypes.bool.isRequired,
    isEdit: PropTypes.bool.isRequired,
    submitForm: PropTypes.func.isRequired,
    setCancel: PropTypes.func.isRequired,
    labels: PropTypes.shape({
        ProjectSingular: PropTypes.string,
        ProjectPlural: PropTypes.string,
        ProjectSingularPossessive: PropTypes.string,
        ProjectPluralPossessive: PropTypes.string,
        TaskSingular: PropTypes.string,
        TaskPlural: PropTypes.string,
        TaskSingularPossessive: PropTypes.string,
        TaskPluralPossessive: PropTypes.string,
        FormSingular: PropTypes.string,
        FormPlural: PropTypes.string,
        FormSingularPossessive: PropTypes.string,
        FormPluralPossessive: PropTypes.string,
    }),
}

export default ProjectSubmitCancel